import { Affiliate, AffiliateStatus } from "./Affiliate";
import { PurchaseRuleLink } from "./PurchaseRuleLink";
import { NetworkPreferences } from "./UserPreferences";

export enum XolaPartnerConnectionType {
    SUPPLIER = "supplier",
    RESELLER = "reseller",
    SUPPLIER_RESELLER = "supplier_reseller",
}

export enum XolaPartnerStatus {
    ACCEPTED = "accepted",
    PENDING = "pending",
    DECLINED = "declined",
    DISCONNECTED = "disconnected",
    ARCHIVED = "archived",
    REQUESTED = "requested", //only ui status, will not store in DB
}

export interface XolaPartner {
    id: ID;
    purchaseRuleLink?: PurchaseRuleLink;
    connectionType: XolaPartnerConnectionType;
    status: XolaPartnerStatus;
    seller: { id: ID };
    partnerSeller: XolaPartnerContextSeller;
    initiator: { id: ID };
    object: PartnerObject;
    name: string;
    address: string;
    email: string;
    phone: string;
    viewPurchases: boolean;
    editPurchases: boolean;
}

export enum PartnerObject {
    XOLA_PARTNER = "xola_partner",
    AFFILIATE = "affiliate",
}

export interface XolaPartnerContextSeller {
    id: ID;
    name: string;
    city: string;
    state?: string;
    country?: string;
    streetAddress?: string;
    website: string;
    picture: { id: ID };
    preferences: {
        network: NetworkPreferences;
    };
}

//TODO: Resolve this, we need to use AbstractPartner
export type Partner = Omit<Affiliate, "status" | "object"> &
    Omit<XolaPartner, "status"> & {
        status: AffiliateStatus | XolaPartnerStatus;
    };
